import gql from 'graphql-tag'

const GerarPushSubscriptionGql = gql`
  mutation GerarPushSubscription($input: PushSubscriptionInput!) {
    gerarPushSubscription(pushSubscriptionInput: $input)
  }
`

export const register = async (vapidPublicKey, client) => {
  const isServiceWorker = 'serviceWorker' in navigator
  const isNotification = 'Notification' in window
  const isEdge = navigator.userAgent.indexOf('Edge') > -1

  if (isServiceWorker && isNotification && !isEdge) {
    await navigator.serviceWorker.register(`/sw-portal.js`)
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      registerSubscription(vapidPublicKey, client)
    }
  }
}

const registerSubscription = async (vapidPublicKey, client) => {
  const registration = await navigator.serviceWorker.ready

  if (registration == null || registration.pushManager == null) {
    return
  }
  let subscription = await registration.pushManager.getSubscription()
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: vapidPublicKey
    })
  }
  generateSubscription(subscription.toJSON(), client)
}

const generateSubscription = (subscription, client) => {
  client.mutate({
    mutation: GerarPushSubscriptionGql,
    variables: {
      input: {
        endpoint: subscription.endpoint,
        auth: subscription.keys.auth,
        key: subscription.keys.p256dh
      }
    }
  })
}
